import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet
} from "@insite/client-framework/HandlerCreator";
import { getDealers, GetDealersApiParameter } from "@insite/client-framework/Services/DealerService";
import { DealerCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<
    HasOnSuccess<DealerCollectionModel> & HasOnError<string> & GetDealersApiParameter,
    DealerCollectionModel
>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getDealers(props.apiParameter as any);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const customloadDealers = createHandlerChainRunner(chain, "LoadDealers");
export default customloadDealers;
